__turbopack_context__.v({
  "mainImageContainer": "G8SbeG_mainImageContainer",
  "mainImageContainerImg": "G8SbeG_mainImageContainerImg",
});
